import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
import moment from "moment";
import XLSX from "xlsx";
import Dropzone from "../../../views/DropZone.vue";

export default {
  name: "service-module-reports",
  components: { Dropzone, pageheader },
  data() {
    return {
      input: {},
      rules: rules,
      showdropzone: false,
      valid: true,
      dropdata: 0,
      serviceModuleReportList: [],
      overDueServicesList: [],
      upcomingServicesList: [],
      isLoadCards: false,
      linkWorkOrderDialog: false,
      workOrdersList: [],
      selectedWorkOrder: {},
      menu: false,
      serviceDate: "",
      serviceHours: "",
      serviceMiles: "",
      notes: "",
      iSubmitWorkOrder: false,
      assetCardId: "",
      isWorkOrdersList: false,
      isWorkOrderInfo: false,
      cardObj: {},
      files: [],
      searchWorkOrder: null,
      serviceCardsBtnToggle: 0,
      overDueUpcomingHeaders: [
        { text: "Equipment", value: "stockKey" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Equipment SN", value: "equipmentSN" },
        { text: "Template", value: "templateName" },
        { text: "Status", value: "status" },
        { text: "Hours", value: "currentHours" },
        { text: "Hours Service", value: "serviceHours" },
        { text: "Hours to Next Service", value: "dueDetails" },
      ],
      overDueUpcomingSearch: "",
      pageNumber: 1,
      pageSize: -1,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      isExcelLoading: false,
      options: {},
    };
  },
  watch: {
    deep: true,
    immediate: true,
    searchWorkOrder(val) {
      if (val != undefined) {
        this.searchWorkOrders(val);
      }
    },
  },
  computed: {
    ...mapGetters(["roles", "serviceRecordsToggle", "fullname"]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    numberFormat: function (value) {
      if (value != "Quarterly" || value != "Monthly" || value != "yearly") {
        return Number(value).toLocaleString();
      }
    },
    mathRoundFilter: function (value) {
      if (value) {
        return Math.round(value);
      }
    },
  },
  created() {
    this.serviceCardsBtnToggle = this.serviceRecordsToggle;
  },
  mounted() {
    this.input = utils.getInputContent("services", this.roles);
    this.getServiceModuleReport();
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setServiceRecordsToggle", 0);
  },
  methods: {
    onToggleChange() {
      this.$store.dispatch(
        "setServiceRecordsToggle",
        this.serviceCardsBtnToggle
      );
      this.getServiceModuleReport();
    },
    enableDropzone() {
      if (
        this.serviceHours != "" &&
        parseFloat(this.serviceHours) >= 0 &&
        this.serviceHours != null
      ) {
        this.showdropzone = true;
      } else {
        this.showdropzone = false;
        this.files = [];
      }
      this.dropdata += 1;
    },
    async getServiceModuleReport() {
      this.isLoadCards = true;
      this.serviceModuleReportList = [];
      this.overDueServicesList = [];
      this.upcomingServicesList = [];
      try {
        let response = await telematicsService.getServiceRecords(
          this.pageNumber,
          this.pageSize
        );
        if (response.isSuccess) {
          this.isLoadCards = false;
          this.serviceModuleReportList = response.data;
          this.overDueServicesList = response.data.filter(
            (item) => item.status == "Overdue"
          );
          this.upcomingServicesList = response.data.filter(
            (item) => item.status == "Due"
          );
        } else {
          this.isLoadCards = false;
          this.serviceModuleReportList = [];
          this.overDueServicesList = [];
          this.upcomingServicesList = [];
        }
      } catch (err) {
        this.isLoadCards = false;
        console.log(err);
      }
    },
    async searchWorkOrders(val) {
      this.isWorkOrdersList = true;
      try {
        let response = await telematicsService.getSearchWorkOrders(val);
        if (response.isSuccess) {
          this.isWorkOrdersList = false;
          this.workOrdersList = response.data;
          let tempWorkOrders = [];
          var dateFormat = "MM/DD/YYYY";
          tempWorkOrders = response.data.map(function (element) {
            return {
              cEndDate: element.contractEndDate
                ? moment(element.contractEndDate).local().format(dateFormat) +
                  " - "
                : moment(element.contractStartDate).local().format(dateFormat) +
                  " - ",
              cId: element.contractId ? element.contractId + " - " : "",
              cDepotId: element.depotId ? element.depotId + " - " : "",
              cStatus: element.contractStatus ? element.contractStatus : "",
              contractEndDate: element.contractEndDate,
              contractId: element.contractId ? element.contractId : "",
            };
          });
          this.workOrdersList = tempWorkOrders.map(function (element) {
            return {
              wName:
                element.cId +
                element.cDepotId +
                element.cEndDate +
                element.cStatus,
              contractId: element.contractId ? element.contractId : "",
              contractEndDate: element.contractEndDate
                ? element.contractEndDate
                : "",
            };
          });
        } else {
          this.isWorkOrdersList = false;
          this.workOrdersList = [];
        }
      } catch (err) {
        this.isWorkOrdersList = false;
        console.log(err);
      }
    },
    async getWorkOrdersList() {
      this.isWorkOrdersList = true;
      try {
        let response = await telematicsService.getWorkOrders();
        if (response.isSuccess) {
          this.isWorkOrdersList = false;
          this.workOrdersList = response.data;
          let tempWorkOrders = [];
          var dateFormat = "MM/DD/YYYY";
          tempWorkOrders = response.data.map(function (element) {
            return {
              cEndDate: element.contractEndDate
                ? moment(element.contractEndDate).local().format(dateFormat) +
                  " - "
                : moment(element.contractStartDate).local().format(dateFormat) +
                  " - ",
              cId: element.contractId ? element.contractId + " - " : "",
              cDepotId: element.depotId ? element.depotId + " - " : "",
              cStatus: element.contractStatus ? element.contractStatus : "",
              contractEndDate: element.contractEndDate,
              contractId: element.contractId ? element.contractId : "",
            };
          });
          this.workOrdersList = tempWorkOrders.map(function (element) {
            return {
              wName:
                element.cId +
                element.cDepotId +
                element.cEndDate +
                element.cStatus,
              contractId: element.contractId ? element.contractId : "",
              contractEndDate: element.contractEndDate
                ? element.contractEndDate
                : "",
            };
          });
        } else {
          this.isWorkOrdersList = false;
          this.workOrdersList = [];
        }
      } catch (err) {
        this.isWorkOrdersList = false;
        console.log(err);
      }
    },
    openLinkWorkOrder(item) {
      this.linkWorkOrderDialog = true;
      this.cardObj = item;
      this.enableDropzone();
      this.getWorkOrdersList();
    },
    CloseDialog() {
      this.linkWorkOrderDialog = false;
      this.selectedWorkOrder = {};
      this.menu = false;
      this.serviceDate = "";
      this.serviceHours = "";
      this.serviceMiles = "";
      this.notes = "";
      this.$refs.dropzone.removeAllFiles();
    },
    async getWorkOrderInfo() {
      this.isWorkOrderInfo = true;
      try {
        let response = await telematicsService.getWorkOrderInformation(
          this.cardObj.equipmentId
        );
        if (response.isSuccess) {
          this.isWorkOrderInfo = false;
          let workOrderData = response.data;
          this.serviceDate =
            this.selectedWorkOrder.contractEndDate.split("T")[0];
          this.serviceHours = workOrderData.serviceHours;
          this.serviceMiles = workOrderData.serviceMiles;
          if (this.serviceHours) {
            this.showdropzone = true;
          }
        } else {
          this.isWorkOrderInfo = false;
          this.serviceDate = "";
          this.serviceHours = "";
          this.serviceMiles = "";
        }
      } catch (err) {
        this.isWorkOrderInfo = false;
        console.log(err);
      }
    },
    ClearWorkOrder() {
      if (this.selectedWorkOrder) {
        this.selectedWorkOrder = {};
      }
    },
    ClearServiceDate() {
      if (this.serviceDate) {
        this.serviceDate = "";
      }
    },
    async submitWorkOrder() {
      this.iSubmitWorkOrder = true;
      let payload = {
        serviceLinkRecordId: this.cardObj.id,
        serviceScheduleId: this.cardObj.serviceScheduleId,
        workOrderId: this.selectedWorkOrder.contractId,
        equipmentId: this.cardObj.equipmentId,
        notes: this.notes,
        serviceHours: Number(this.serviceHours),
        serviceMiles: Number(this.serviceMiles),
        serviceDate: this.serviceDate,
        serviceFiles: this.files.length > 0 ? this.files : [],
        createdBy: this.fullname,
      };
      try {
        let response = await telematicsService.submitWorkOrderInfo(payload);
        if (response.isSuccess) {
          this.iSubmitWorkOrder = false;
          this.CloseDialog();
          this.$toast.success(
            "Service schedule is linked with work order successfully"
          );
          this.getServiceModuleReport();
        } else {
          this.iSubmitWorkOrder = false;
          this.$toast.error(
            "Unable to link the service schedule with work order"
          );
        }
      } catch (err) {
        this.iSubmitWorkOrder = false;
        this.$toast.error(
          "Unable to link the service schedule with work order"
        );
        console.log(err);
      }
    },
    exportTableData() {
      this.isExcelLoading = true;
      this.excelHeader = [];
      this.startrow = 3;
      this.excelHeader.push(["Services"]);
      this.excelHeader.push([]);
      this.startrow += 1;
      this.excelHeader.push([
        "Equipment",
        "Telematics SN",
        "Equipment SN",
        "Template",
        "Status",
        "Hours",
        "Hours Service",
        "Hours to Next Service",
        // "Miles",
        // "Miles Service",
      ]);
      let tempExcel = this.serviceModuleReportList.map(function (item) {
        delete item.id;
        delete item.serviceScheduleId;
        delete item.workOrderId;
        delete item.serviceDate;
        delete item.notes;
        delete item.equipmentId;
        delete item.customerId;
        delete item.stockId;
        delete item.templateId;
        delete item.unitId;
        delete item.currentMiles;
        delete item.serviceMiles;

        return item;
      });

      let datarow = "A" + this.startrow;
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header: [
          "stockKey",
          "tuSerialNumber",
          "equipmentSN",
          "templateName",
          "status",
          "currentHours",
          "serviceHours",
          "dueDetails",
          // "currentMiles",
          // "serviceMiles",
        ],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Services");
      this.excelHeader = [];
      XLSX.writeFile(wb, "Services.xlsx");
      this.isExcelLoading = false;
    },
    dropzoneS(file) {
      utils.fileToBase64(file).then((base64String) => {
        let filetype = file.type;
        if (
          file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          filetype = "application/vnd.ms-excel";
        } else {
          filetype = file.type;
        }
        let fileData = {
          fileType: filetype,
          fileName: file.name,
          base64File: base64String.split(",")[1],
        };
        this.files.push(fileData);
      });
    },
    dropzoneR(file) {
      utils.fileToBase64(file).then((base64String) => {
        let filterFiles = this.files.filter(function (a) {
          return a.fileName != file.name && a.fileContent != base64String;
        });
        this.files = filterFiles;
      });
    },
  },
};
